const EXTRA_FEE = 0.12;

export function calculateFee(total: number): number {
  return EXTRA_FEE * total;
}
